module.exports = __webpack_public_path__ + "img/element_2.924ca8da.png";